import Carousel from 'element-ui/packages/carousel';
const carouselItemClass = 'el-carousel__item';
let xDown = null;
let yDown = null;

export default {
	extends: Carousel,
	methods: {
		initSwipe() {
			let carouselItems = document.getElementsByClassName(carouselItemClass);
			for (let carouselItem of carouselItems) {
				carouselItem.addEventListener('touchstart', this.handleTouchStart, false);
				carouselItem.addEventListener('touchmove', this.handleTouchMove, false);
			}
		},
		handleTouchStart(evt) {
			xDown = evt.touches[0].clientX;
			yDown = evt.touches[0].clientY;
		},
		handleTouchMove(evt) {
			if (!xDown || !yDown) {
				return;
			}

			let xUp = evt.touches[0].clientX;
			let yUp = evt.touches[0].clientY;

			let xDiff = xDown - xUp;
			let yDiff = yDown - yUp;

			if (Math.abs(xDiff) > Math.abs(yDiff)) {
				/* most significant*/
				if (xDiff > 0) {
					this.next();
				} else {
					this.prev();
				}
			}
			/* reset values */
			xDown = null;
			yDown = null;
		},
		// @Override
		updateItems() {
			this.items = this.$children.filter((child) => child.$options.name === 'CarouselItem');
		}
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	mounted() {
		this.initSwipe();
	}
};
